import React from 'react';

const MoneyInput = ({ onChange, onKeyDown, onFocus, onBlur, className = "", placeholder = "0", readOnly = false, ...props }) => {
  const handleChange = (e) => {
    if (readOnly) return;
    const value = e.target.value.replace(/[^0-9]/g, '');
    e.target.value = value ? parseInt(value).toLocaleString() : '';
    onChange(+value || 0);
  };

  return (
    <input 
      type="text"
      onChange={handleChange}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      className={className}
      placeholder={placeholder}
      readOnly={readOnly}
      {...props}
    />
  );
};

export default MoneyInput;